import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Music2, Mail, Facebook, Instagram, Youtube } from 'lucide-react';

// TikTok icon component (not available in lucide-react)
const TikTokIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export default function Footer() {
  const navigate = useNavigate();

  const socialLinks = [
    {
      name: 'Facebook',
      icon: Facebook,
      url: 'https://www.facebook.com/share/1AENG6pvW1/?mibextid=wwXIfr'
    },
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/razientsounds?igsh=ejAzdTRwZHBldTk0&utm_source=qr'
    },
    {
      name: 'YouTube',
      icon: Youtube,
      url: 'https://youtube.com/@razientsounds?si=_Rx3OjJWpHASF9Tl'
    },
    {
      name: 'TikTok',
      icon: TikTokIcon,
      url: 'https://www.tiktok.com/@razientsounds?_r=1&_t=ZT-92A8fXKfbck'
    }
  ];

  return (
    <footer className="relative z-10 border-t border-white/10 glass-heavy mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Music2 className="text-violet-400" size={32} />
              <span className="text-xl font-bold gradient-text">RazientSounds</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Connecting event organizers with exceptional artists. Book your perfect performance today.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h3 className="font-bold text-white mb-4">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/browse')} className="text-white/60 hover:text-white transition">
                  Browse Artists
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/events')} className="text-white/60 hover:text-white transition">
                  Events
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/blog')} className="text-white/60 hover:text-white transition">
                  Blog
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-bold text-white mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/help')} className="text-white/60 hover:text-white transition">
                  Help Center
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/faq')} className="text-white/60 hover:text-white transition">
                  FAQs
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/support')} className="text-white/60 hover:text-white transition">
                  Support Tickets
                </button>
              </li>
              <li>
                <a href="mailto:OurTeamProduction@razientsounds.com" className="text-white/60 hover:text-white transition">
                  Contact Us
                </a>
              </li>
              <li>
                <button onClick={() => navigate('/terms')} className="text-white/60 hover:text-white transition">
                  Terms of Service
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/privacy')} className="text-white/60 hover:text-white transition">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="font-bold text-white mb-4">Connect</h3>
            <div className="flex gap-3 mb-4">
              {socialLinks.map((social) => (
                <a 
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-violet-500/30 flex items-center justify-center transition"
                  title={social.name}
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div>
            <a 
              href="mailto:OurTeamProduction@razientsounds.com"
              className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition"
            >
              <Mail size={16} />
              OurTeamProduction@razientsounds.com
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} RazientSounds. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <button onClick={() => navigate('/terms')} className="text-white/40 hover:text-white transition">
              Terms
            </button>
            <button onClick={() => navigate('/privacy')} className="text-white/40 hover:text-white transition">
              Privacy
            </button>
            <button onClick={() => navigate('/help')} className="text-white/40 hover:text-white transition">
              Help
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
